//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export abstract class ScraperUrlConstants
{
	public static scraperIdVariable: string = `$scraperId`;
	public static scraperWebPageIdVariable: string = `$scraperWebPageId`;
	public static scrapersUrl: string = `/Scrapers`;
	public static scrapersPublicScrapersUrl: string = `/Scrapers/PublicScrapers`;
	public static scrapersUserScrapersUrl: string = `/Scrapers/UserScrapers`;
	public static scraperScrapedResultsUrlTemplate: string = `/Scrapers/ScrapedResults/$scraperId`;
	public static scraperCreateUrl: string = `/Scrapers/Create`;
	public static scraperDetailUrlTemplate: string = `/Scrapers/Detail/$scraperId`;
	public static scraperDetailOverviewUrlTemplate: string = `/Scrapers/Detail/Overview/$scraperId`;
	public static scraperDetailStatisticsUrlTemplate: string = `/Scrapers/Detail/Statistics/$scraperId`;
	public static scraperDetailWebPageUrlTemplate: string = `/Scrapers/Detail/WebPage?scraperId=$scraperId&scraperWebPageId=$scraperWebPageId`;
	public static scraperDetailWebPageOverviewUrlTemplate: string = `/Scrapers/Detail/WebPage/WebPageOverview?scraperId=$scraperId&scraperWebPageId=$scraperWebPageId`;
	public static scraperDetailWebPageTurboFrameUrlTemplate: string = `/Scrapers/Detail/WebPage/WebPageTurboFrame?scraperId=$scraperId&scraperWebPageId=$scraperWebPageId`;
	public static scraperDetailWebPageScrapedResultsUrlTemplate: string = `/Scrapers/Detail/WebPage/WebPageScrapedResults?scraperId=$scraperId&scraperWebPageId=$scraperWebPageId`;
	public static scraperDetailBadgesUrlTemplate: string = `/Scrapers/Detail/Badges/$scraperId`;
	public static scraperDetailActionsUrlTemplate: string = `/Scrapers/Detail/Actions/$scraperId`;
	public static scraperDetailActionsMakePublicUrlTemplate: string = `/Scrapers/Detail/Actions/$scraperId?handler=MakePublic`;
	public static scraperDetailActionsRequestToMakePublicUrlTemplate: string = `/Scrapers/Detail/Actions/$scraperId?handler=RequestToMakePublic`;
	public static scrapersManageUrl: string = `/Scrapers/Manage`;
	public static scrapersManageUserScrapersUrl: string = `/Scrapers/Manage/UserScrapers`;
	public static scrapersManageOtherUsersScrapersUrl: string = `/Scrapers/Manage/OtherUsersScrapers`;
}
